@if (toolbarNav && menuCustom) {
  <navbar [title]="menuCustom.title">
    <button (click)="actionFirstButton()" siraButton left  variant="tertiary">
      <i class="material-icons">{{ menuCustom.firstButton.icon }}</i>
      Voltar
    </button>

    @if (!menuCustom?.lastButton) {
      <button (click)="openWhatsApp()" siraButton right variant="tertiary">
        Ajuda
        <i class="material-icons">contact_support</i>
      </button>
    }
  </navbar>
}

@if (toolbarNav && !menuCustom) {
  <navbar>
    <button (click)="toggle(sidenav)" siraButton left variant="tertiary">
      <i class="material-icons">menu</i>
      Menu
    </button>
    <button (click)="openWhatsApp()" siraButton right variant="tertiary">
      Ajuda
      <i class="material-icons">contact_support</i>
    </button>
  </navbar>
}


<mat-sidenav-container [class.full]="!toolbarNav" class="app-container">
  <mat-sidenav #sidenav [class.mat-elevation-z4]="true" class="app-sidenav" mode="push">
    <mat-nav-list>
      @if (user) {
        <mat-list-item [activated]="false">
          <mat-icon matListItemIcon>person</mat-icon>
          <span matListItemTitle>{{ user?.personProperties?.name }} <br/>{{ user?.document }} </span>
        </mat-list-item>
      }
      <div class="example-spacer"></div>
      @if (isDestktop) {
        <a (click)="openWhatsApp()">
          <mat-list-item>
            <mat-icon matListItemIcon>contact_support</mat-icon>
            <span matListItemTitle>
              <span [innerHTML]="'menu.layout.item.support' | localeValue"></span>
            </span>
          </mat-list-item>
        </a>
      }
      <a (click)="changeLocale()">
        <mat-list-item>
          <mat-icon matListItemIcon>translate</mat-icon>
          <span matListItemTitle>
            <span [innerHTML]="'menu.layout.item.locale' | localeValue"></span>
            : {{ jwtAuthService.localeValue }}
          </span>
        </mat-list-item>
      </a>
      @if (user) {
        <a (click)="anvisaRegulation()">
          <mat-list-item>
            <mat-icon matListItemIcon>article</mat-icon>
            <span matListItemTitle>
              <span [innerHTML]="'menu.layout.item.security' | localeValue"></span>
            </span>
          </mat-list-item>
        </a>
      }
      @if (user) {
        <a (click)="logout()">
          <mat-list-item>
            <mat-icon matListItemIcon>logout</mat-icon>
            <span matListItemTitle>
              <span [innerHTML]="'menu.layout.item.logout' | localeValue"></span>
            </span>
          </mat-list-item>
        </a>
      }
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content id="main-content">
    <div [class.full]="!toolbarNav" class="app-sidenav-content">
      <router-outlet/>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>

